/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.membership-fee', {
            parent: 'board',
            url: '/board/{select}/membership-fee?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.membershipFee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/membership-fee/membership-fees.html',
                    controller: 'BoardMembershipFeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'year,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.membership-fee.new', {
            parent: 'board.membership-fee',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/membership-fee/membership-fee-dialog.html',
                    controller: 'BoardMembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                price: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('board.membership-fee');
                });
            }]
        })
        .state('board.membership-fee.delete', {
            parent: 'board.membership-fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/membership-fee/membership-fee-delete-dialog.html',
                    controller: 'BoardMembershipFeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.membership-fee.dept-edit', {
            parent: 'board.membership-fee',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
